var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBigRibbon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 951.696,
    height: 603.248,
    viewBox: "0 0 951.696 603.248",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "bigRibbon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.418,214.671c-9.915-4.421-16.281-14.626-18.806-25.184s-1.773-21.588-1.005-32.416c.626-8.837,1.451-18.224,6.797-25.287,8.847-11.689,25.882-12.29,40.535-11.819,14.162.455,30.349,1.918,38.767,13.316,6.511,8.815,6.115,20.77,5.438,31.708-.603,9.743-1.241,19.653-4.662,28.795s-10.1,17.571-19.352,20.681c-10.621,3.571-22.177-.359-33.38-.156-12.165.221-12.948-3.183-21.162,5.793-5.788,6.325-20.839,26.427-24.502,34.179-28.411,60.128-50.377,119.827-65.401,184.61-5.461,23.548-10.248,47.912-23.274,68.276-11.357,17.755-30.826,31.958-51.399,32.483-3.722.095-5.913,4.196-4.045,7.417.879,1.516,1.795,2.955,2.834,4.139,3.887,4.429,7.822,8.901,12.623,12.319,12.355,8.794,28.932,9.448,43.732,6.138s28.541-10.126,42.794-15.31c12.142-4.416,25.205-7.667,37.933-6.376,3.95.4,7.649-1.95,8.959-5.698,7.383-21.111,15.209-41.984,22.486-63.152,4.152-12.079,8.327-24.249,10.106-36.897,1.776-12.625,1.126-25.45.45-38.182-2.084-39.262-4.382-78.559-3.605-117.869.492-24.907,4.979-45.177,20.168-64.923,18.151,50.64,22.197,98.494,18.222,152.141-1.278,17.255-3.189,34.486-3.311,51.787-.303,42.915,10.676,85.85,31.45,123.395,2.088,3.773,6.901,5.215,10.582,2.967,7.957-4.86,18.449-4.915,27.741-1.6,11.844,4.226,21.986,12.178,33.448,17.353,28.401,12.823,64.284,5.725,86.375-16.004,2.744-2.699,1.493-7.359-2.239-8.301-22.695-5.728-50.072-29.192-62.271-46.501-12.686-18-25.968-102.402-31.456-123.728-24.227-94.133-33.553-139.456-104.499-156.183,22.708,2.629,42.004,13.914,57.152,31.034,8.549,9.662,15.015,20.979,23.12,31.015,16.474,20.4,39.061,34.781,61.226,48.791,11.001,6.954,23.851,14.209,36.337,10.019,3.258-1.093,6.25-2.962,8.333-5.695,5.544-7.272,1.892-15.588.031-23.435-3.934-16.586.774-34.977,12.194-47.632,6.421-7.115,14.671-12.377,21.176-19.416,10.707-11.587,16.078-27.918,14.34-43.598s-10.556-30.438-23.541-39.399c-23.549-16.251-55.381-11.971-82.853-3.973-27.472,7.998-55.522,19.184-83.766,14.604",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.955,126.379c11.043-29.125,31.52-56.632,47.703-83.247,8.921-14.673,20.619-30.227,37.635-32.54,12.135-1.649,24.044,4.019,34.345,10.64,18.925,12.164,35.657,28.505,45.363,48.801,9.706,20.296,19.871,54.128-10.537,78.454",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.081,126.379c-3.522-32.643-27.884-61.758-50.322-85.728-15.246-16.288-36.037-31.782-57.863-27.156-6.818,1.445-13.092,4.797-18.887,8.669-25.581,17.093-43.27,45.532-47.293,76.035-2.026,15.362.105,32.855,11.849,42.964,6.253,5.382,14.396,7.931,22.33,10.193,40.061,11.421,81.234,18.94,122.747,22.416",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.346,147.931c-20.61,5.614-46.829,17.726-51.501,38.569s39.378,52.389,54.19,67.78c21.403,22.238-9.262,75.495,5.942,83.883,6.99,4.194,37.332-9.555,53.303-22.009,15.971-12.453,49.164-61.735,68.393-68.092",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 7
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "d",
    "data-name": "bigRibbonWhite"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311.635,90.583c12.005-18.348,24.84-36.152,38.454-53.34,4.325-5.461,9.653-11.335,16.618-11.457,5.581-.098,10.429,3.588,14.774,7.092",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.774,180.211c2.858,6.386,4.452,13.333,4.665,20.326.137,4.494-.318,9.101-2.197,13.186-2.077,4.517-5.737,8.086-9.415,11.432-8.523,7.753-17.63,14.957-25.031,23.788s-13.09,19.672-13.243,31.192",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.34,301.621c7.083,7.002,15.209,12.947,24.027,17.579,2.868,1.506,6.651,2.784,9.09.652,3.074-2.687.925-7.733,1.713-11.739",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.55,488.304c2.624,5.935,5.248,11.871,7.873,17.806,2.328,5.266,4.666,10.55,7.67,15.461,9.568,15.64,26.035,26.884,44.085,30.101",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.404,239.791c7.227,30.286,10.08,53.432,12.063,84.505,2.117,33.168,1.213,66.487,3.753,99.625s4.677,75.578,19.989,105.077",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.697,224.222c-18.73,27.202-35.706,65.603-47.731,96.363-12.025,30.759-21.297,60.669-25.145,96.797",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.542,480.883c-5.246,16.039-10.491,32.077-15.737,48.116",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.499,271.806c4.304,9.195,3.449,24.498,1.801,37.268-.784,6.071,6.052,10.17,11.054,6.642,4.275-3.015,25.37-17.396,10.584-8.309",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.221,203.14c-1.458-7.268-2.792-15.332,1.049-21.672,2.799-4.62,7.858-7.379,12.925-9.253,9.119-3.373,19.039-4.558,28.696-3.428",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.015,126.379c-9.066-2.653-14.222-12.931-13.8-22.368s5.192-18.1,10.409-25.975c8.879-13.401,19.421-25.699,31.308-36.521,2.59-2.358,5.32-4.693,8.598-5.928,6.042-2.276,12.877-.426,18.653,2.459,8.85,4.42,16.469,11.274,21.798,19.608",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.717,97.019l12.177,21.504",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.928,79.396c6.291,11.312,7.689,36.057,6.291,40.461s-.627,12.094-16.041,16.288",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigRibbon);
export default __webpack_public_path__ + "static/media/bigRibbon.391a5bc6eb7b206938a2fed0ebc8f4ee.svg";
export { ForwardRef as ReactComponent };